// extracted by mini-css-extract-plugin
module.exports = {"container":"gallery2_container__3D7TX","img":"gallery2_img__1vTZ6"};